export const gifList = [
  {
    id: 0,
    link: require("../assets/gifs/1.gif"),
  },
  {
    id: 1,
    link: require("../assets/gifs/2.gif"),
  },
  {
    id: 2,
    link: require("../assets/gifs/3.gif"),
  },
  {
    id: 3,
    link: require("../assets/gifs/4.gif"),
  },
  {
    id: 4,
    link: require("../assets/gifs/5.gif"),
  },
  {
    id: 5,
    link: require("../assets/gifs/6.gif"),
  },
  {
    id: 6,
    link: require("../assets/gifs/7.gif"),
  },
];
